import React from "react";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import i18n from "./config/i18n";
import { Store } from "./services/Store";
import "./style/index.css";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  // <React.StrictMode>
  <I18nextProvider i18n={i18n}>
    <Provider store={Store}>
      <BrowserRouter>
        <GoogleReCaptchaProvider reCaptchaKey="6LdFATosAAAAAJlaaNXFCRGLOcBvg9Vd1q-zvPTX">
          <App />
        </GoogleReCaptchaProvider>
      </BrowserRouter>
    </Provider>
  </I18nextProvider>
  // </React.StrictMode>
);
